import React, { useRef } from 'react'
import Box from '@material-ui/core/Box';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Grid from '@toast-ui/react-grid';
import SaveIcon from "@material-ui/icons/Save";
import axios from 'axios';
import swal from 'sweetalert'
import '../Shared/Css/IpgoItemSerche.css'


const style = {
  position: 'absolute',
  top: '58%',
  left: '55%',
  transform: 'translate(-50%, -50%)',
  width: 1200,
  height: 450,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderColor: "primary.light",
  verticalAlign: "middle",
  display: "table-cell",
  //boxShadow: 20,
  p: 2, //padding 설정
};

function IpgoItemSerche(props) {
  //console.log('여기')
  //console.log("넣김값:", props.dataItem)
  const gridRef = useRef();

  const columns = [
    {
      name: "item_bel_meng", header: "차종", align: "center", width: 60,
      renderer: {
        styles: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: (props) => props.value.length > 3 ? '#000080' : '#000080'
        }
      }
    },
    {
      name: "item_사용유무", header: "사용", align: "center", width: 50,
      renderer: {
        styles: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: (props) => props.value === '미사용' ? '#ccc' : 'blue'
        }
      }
    },
    {
      name: "item", header: "우리품번", align: "center", width: 65,
      renderer: {
        styles: {
          fontWeight: 'bold',
          color: 'blue',
          fontFamily: "sans-serif",
          fontSize: '14px',
        }
      }
    },
    {
      name: "item_work_cheri_description", header: "작업방법", align: "left", width: 125,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
          color: (props) => props.value.replace(/[^0-9]/g, "") > 1 ? 'red' : '#000080'  //숫자추출하여 2공장시 빨간색
        }
      }
    },
    {
      name: "item_upche_item", header: "업체품번[사진]", align: "left", width: 120,
      renderer: {
        styles: {
          fontWeight: 'normal',
          color: '#008000',
          fontSize: '12px',
        }
      }
    },
    {
      name: "item_upche_name", header: "품명", align: "left", width: 140,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "item_제품규격", header: "제품규격", align: "left", width: 120,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "item_upche_sangho", header: "업체명", align: "left", width: 117,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "item_label_color", header: "라벨", align: "center", width: 25,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "item_box_each", header: "당량", align: "right", width: 25,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      },
      formatter: function (ev) {
        return `${ev.value.toLocaleString('ko-KR')}`
      }
    },
    {
      name: "item_daewi", header: "단위", align: "center", width: 25,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "item_danga_pimac", header: "피단", align: "right", width: 25,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "item_do_danwie", header: "단위", align: "center", width: 25,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "item_danga_dopo", header: "도단", align: "right", width: 25,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
    {
      name: "item_공장간이동전표출력", header: "2출력", align: "center", width: 25,
      renderer: {
        styles: {
          fontWeight: 'normal',
          fontSize: '12px',
        }
      }
    },
  ];

  const rows = props.dataItem.map((row) => ({
    item_bel_meng: row.item_bel_meng,
    item: row.item,
    item_work_cheri_description_move: row.item_work_cheri_description_move,
    item_work_cheri_description: row.item_work_cheri_description + " [" + row.item_이동처리방법 + "]",
    item_work_cheri_line: row.item_work_cheri_line,
    item_cheri_code: row.item_cheri_code,
    item_최종공정라인: row.item_최종공정라인,
    item_factory: row.item_factory,
    item_이동처리방법: row.item_이동처리방법,
    item_upche_item: row.item_공용품번 ? (row.item_upche_item + " [" + row.item_공용품번 + "]") : row.item_upche_item,
    item_upche_name: row.item_upche_name,
    item_제품규격: row.item_제품규격,
    item_upche_sangho: row.item_upche_sangho,
    item_upche_code: row.item_upche_code,
    item_label_color: row.item_label_color,
    item_gress_weight: row.item_gress_weight,
    item_box_each: row.item_box_each,
    item_daewi: row.item_daewi,
    item_danga_pimac: row.item_danga_pimac,
    item_do_danwie: row.item_do_danwie,
    item_danga_dopo: row.item_danga_dopo,
    item_danga: row.item_danga,
    item_price_sangtae: row.item_price_sangtae,
    item_사용유무: row.item_사용유무,
    item_공용품번: row.item_공용품번,
    item_공장간이동전표출력: row.item_공장간이동전표출력,
  }));

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      // border: 'red',
      border: '#42a5f5',
    },
    outline: {
      border: '#59b9ea',
      showVerticalBorder: true,
    },
    scrollbar: {
      border: '#59b9ea',
      thumb: 'blue'
    },
    cell: {
      normal: {
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
    },
    area: {
      header: {
        border: '#59b9ea',
        //background: 'blue',
        showVerticalBorder: false,
        showHorizontalBorder: false,
      },
    },
    //호버설정
    row: {
      hover: {
        background: 'silver'
      }
    }
  });

  //더블클릭스 수정이벤트
  const handleDbClick = (ev) => {
    var rowKey = ev.rowKey
    var DbclickValue = gridRef.current.getInstance().getRow(ev.rowKey)

    if (ev.rowKey === rowKey && ev.columnName === 'item') {
      //console.log('잘처리됨');console.log(clickValue.id);console.log(clickValue.t01);console.log(clickValue.t02);console.log(clickValue.t03);
      props.setDbClickValue(DbclickValue);
      props.setCopen(false);
    }
    else {
      console.log('작지번호 필드가 아님');
    }
  };
  //클릭 사진보기
  const handleClick = (ev) => {
    var rowKey = ev.rowKey
    var clickValue = gridRef.current.getInstance().getRow(ev.rowKey)
    if (ev.rowKey === rowKey && ev.columnName === 'item_upche_item') {
      axios.get(`/IpgoReact/ItemImgIndex?ItemSabun=${clickValue.item}`)
        .then((res) => {
          if (res.status === 200) {
            const imgitem = res.data;
            swal({
              icon: `data:image/png;base64, ${imgitem[0].file}`,
              title: `품번:${imgitem[0].file_bul}[${clickValue.item_upche_item}]`,
              className: 'swal-wide',
              timer: 10000,
              dangerMode: true,
              animation: false,
              button: {
                text: "닫기",
              },
            })
          }
        })
        .catch(error => {
          console.log(`사진보기필드가 아님:${error}`)
        })
    }
    else if (ev.rowKey === rowKey && ev.columnName === 'item') {
      //console.log('잘처리됨');console.log(clickValue.id);console.log(clickValue.t01);console.log(clickValue.t02);console.log(clickValue.t03);
      props.setDbClickValue(clickValue);
      props.setCopen(false);
    }
  };

  return (
    <div>
      <Modal open={props.copen}>
        <Box sx={{ ...style }} >
          <h4 id="child-modal-title" style={{ color: 'blue' }}>제품정보</h4>
          <div>
            <Grid
              columns={columns}
              data={rows}
              rowColumn={'auto'}
              scrollX={false}
              scrollY={true}
              rowHeight={30} //셀높이설정
              minRowHeight={10}
              bodyHeight={300}
              header={{ height: 28 }} //Body혜드높이 설정
              heightResizable={true}
              usageStatistics={false}
              ref={gridRef}
              columnOptions={{ resizable: true }} //컬럼 넓이마우스조절됨
              //onDblclick={handleDbClick} //사용안함
              onKeyUp={handleDbClick}
              onClick={handleClick}
            />
          </div>
          <Button onClick={() => { props.setCopen(false) }}
            variant="contained"
            startIcon={<SaveIcon />}
            style={{
              height: "30px",
              background: '#689f38',
              color: 'white',
              width: 100,
              marginTop: "2px",
              float: "center",
            }}>닫기</Button>
        </Box>
      </Modal>
    </div>
  );
}
export default IpgoItemSerche